<template>
  <div class="rollingContain" ref="contain">
    <div class="rollingContent" :class="{ inAnimate }" ref="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
/**
 * 扩展性纵向滚动组件,通过slot进行插入,支持滚动所有纵向布局的内容
 * 使用事例:
 * 因为自由度更高,推荐给Rolling组件设置class,自行进行容器样式编写
 * <Rolling>
    <div class="luckItem" v-for="item in list" :key="item">
      <img src="../assets/head_default.png" />
      {{ item }}
    </div>
  </Rolling>
*/
/**
 * 组件会自动计算slot中子元素的高度,进行滚动
 * @prop {Number} clipTime | 5000 滚动间隔时间
 *
 * 注意:
 * 当容器高度或者子元素高度发生变化时,请使用内置update方法进行更新
 * 不支持十分频繁的变化
 * 如有这些需求,请自行编写其他对应组件
 * 事例:
 * <Rolling ref="rolling">{{other contents}}</Rolling>
 * 进行更新: this.$refs.rolling.update()
 */
export default {
  props: ['clipTime'],
  data() {
    return {
      inAnimate: true,
      timer: null
    };
  },
  mounted() {
    window.onresize = () => {
      this.initRolling();
    };
    this.$nextTick(() => {
      this.initRolling();
    });
  },
  beforeDestroy() {
    clearInterval(this.timer); //清除定时器
  },
  methods: {
    initRolling() {
      clearInterval(this.timer); //清除定时器
      let doms = this.$refs.content.children;
      let formatList = [].map.call(doms, e => ({
        dom: e,
        height: e.clientHeight
      }));
      if (!formatList.length || formatList.length < 2) return; //没有长度或者长度为1时不做滚动处理
      this.$refs.contain.style.height = `${formatList[0].height}px`; //设置容器高度
      this.timer = setInterval(() => {
        this.$refs.content.style.marginTop = `-${formatList[0].height}px`; //偏移
        this.$refs.contain.style.height = `${formatList[1].height}px`; //设置容器高度
        setTimeout(() => {
          this.inAnimate = false;
          this.$nextTick(() => {
            if (this.$refs.content && typeof doms[0] === 'object') {
              this.$refs.content.appendChild(doms[0]);
              formatList.push(formatList.shift());
              this.$refs.content.style.marginTop = '0px';
              setTimeout(() => (this.inAnimate = true), 100);
            }
          });
        }, 500);
      }, this.clipTime || 5000);
    },
    update() {
      this.initRolling();
    }
  }
};
</script>

<style lang="less" scoped>
.rollingContain {
  // height: 52px;
  overflow: hidden;
  transition: all 0.5s ease;
}
.inAnimate {
  transition: all 0.5s ease;
}
</style>
